export const DEFAULT_MAIN_BRANCH_NAME = 'Main';
export const DEFAULT_BRANCH_NAME = 'Branch';
